import React from 'react';
import { Link } from 'react-router-dom';
export default function AuthHeader() {
  return (
    <Link to="/"className="text-md md:text-[25px] font-montserrat font-extrabold text-center">
      <span className="text-[#FF8D28]">Easy</span>{' '}
      <span className="text-[#000000]">Suite</span>
    </Link>
  );
}

